import React, { useRef, useEffect, useState } from 'react'
import { ReactComponent as MySVG7 } from '../../../../../assets/brandokuma/symbol/MAN.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/brandokuma/symbol/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/brandokuma/symbol/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/brandokuma/symbol/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/brandokuma/symbol/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/brandokuma/symbol/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/brandokuma/symbol/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/brandokuma/symbol/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/brandokuma/symbol/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/brandokuma/symbol/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/brandokuma/symbol/KIDSBABYUNIT.svg'
import { ReactComponent as MySVG18 } from '../../../../../assets/brandokuma/symbol/LINGERIE.svg'



const renderShape = (currentShape, category, strokeColor = "#7c7d7f") => {
  const isFill =
    currentShape === 'WOMAN' ||
    currentShape === 'LINGERIE' ||
    currentShape === 'PREMIUM DENIM' ||
    currentShape === 'MAN' ||
    currentShape === 'TRF' ||
    currentShape === 'GIRL' ||
    currentShape === 'BOY';

  const commonStyle = isFill ? { fill: strokeColor } : { stroke: strokeColor };


  if (category === 'Woman') {
    switch (currentShape) {
      case 'WOMAN':
        return (
          <MySVG11
            data-testid="svg-woman"
            style={{ width: `3.892mm`, height: "auto", ...commonStyle }}
          />
        );

      case 'LINGERIE':
        return (
          <MySVG18
            data-testid="svg-lingerie"
            style={{ width: `4.4mm`, height: "auto", ...commonStyle }}
          />
        );

      case 'PREMIUM DENIM':
        return (
          <MySVG11
            data-testid="svg-premium-denim"
            style={{ width: '3.852mm', height: "auto", ...commonStyle }}
          />
        );

      case 'BASIC':
        return (
          <MySVG10
            data-testid="svg-basic"
            style={{ width: '3.852mm', height: "auto", ...commonStyle }}
          />
        );

      case 'TRF':
        return (
          <MySVG12
            data-testid="svg-trf"
            style={{ width: '4.237mm', height: "auto", ...commonStyle }}
          />
        );

      default:
        return <></>;
    }
  } else if (category === 'Man') {
    switch (currentShape) {
      case 'DENIMWEAR':
        return (
          <MySVG9
            data-testid="svg-denimwear"
            style={{ width: '4.083mm',  height: "auto", ...commonStyle }}
          />
        );

      case 'MAN':
        return (
          <MySVG7
            data-testid="svg-man"
            style={{ width: '3.852mm',  height: "auto", ...commonStyle }}
          />
        );

      case 'GLOBAL':
        return (
          <MySVG8
            data-testid="svg-global"
            style={{ width: '3.852mm',  height: "auto", ...commonStyle }}
          />
        );

      default:
        return <></>;
    }
  } else if (category === 'Kids') {
    switch (currentShape) {
      case 'GIRL':
        return (
          <MySVG16
            data-testid="svg-girl"
            style={{ width: `3.852mm`, height: "auto", ...commonStyle }}
          />
        );

      case 'KIDS A (BABY GIRL)':
        return (
          <MySVG14
            data-testid="svg-kids-a"
            style={{ width: '3.852mm', height: 'auto', ...commonStyle }}
          />
        );

      case 'BABY UNIQUE':
      case 'KNIT':
      case 'DENIM':
      case 'OUTERWEAR':
        return (
          <MySVG17
            data-testid="svg-baby-unique"
            style={{ width: '4.622mm', height: 'auto', ...commonStyle }}
          />
        );

      case 'BOY':
        return (
          <MySVG15
            data-testid="svg-boy"
            style={{ width: '3.852mm', height: 'auto', ...commonStyle }}
          />
        );

      case 'KIDS O (BABY BOY)':
        return (
          <MySVG13
            data-testid="svg-kids-o"
            style={{ width: '3.852', height: 'auto', ...commonStyle }}
          />
        );

      default:
        return <></>;
    }
  } else {
    return <></>;
  }
};


// Referans adlarıyla bileşenleri tanımlıyoruz
const KEEPAWAY = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue = szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue = szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  
  // size değerinden sadece sayı kısmını al (örn: "1-3 months" -> "1-3")
  const sizeValue = szrgrp?.sizes?.[valueBasedOnInx]?.size;
  const extractedSizeNumber = sizeValue ? sizeValue.match(/\d+-\d+/)?.[0] || sizeValue.match(/\d+/)?.[0] || '' : '';


  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 

      style={{
        position: "absolute", 
        top: `0`,
        left: "0",
        zIndex: 0,
        width: `${referance?.code?.trim()?.replace(/\s+/g, '').toUpperCase() === 'KEEPAWAY' ? 22.1 : (referance?.width || 22)}mm`,
        height: `${referance?.code?.trim()?.replace(/\s+/g, '').toUpperCase() === 'KEEPAWAY' ? 55.1 : (referance?.height || 55)}mm`
      }}
    >
      {(() => {
        // KEEPAWAY için sabit boyutlar: 22mm x 55mm
        const isKeepAway = referance?.code?.trim()?.replace(/\s+/g, '').toUpperCase() === 'KEEPAWAY';
        const referenceWidth = isKeepAway ? 22 : (referance?.width || 22);
        const referenceHeight = isKeepAway ? 55 : (referance?.height || 55);
        let width = `${referenceWidth}mm`;
        let height = `${referenceHeight}mm`;

        if (typeof CardBackBack === "function") {
          return <CardBackBack width={width} height={height} />;
        } else if (typeof CardBackBack === "string") {
          return (
            <img 
              src={CardBackBack} 
              alt="SVG Image" 

              style={{ 
                width: `${width+1}mm`, 
                height:`${height+1}mm`,
                display: 'block',
                objectFit: 'contain',
                zIndex: 1,
      
              }}
            />
          );
        } else {
          return <div>Invalid CardBackBack type: {typeof CardBackBack}</div>;
        }
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"8.83px", top:"20.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}

        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"35.5px", width:"100%", display:"flex", justifyContent:"flex-end",zIndex:2,flexDirection:"column" ,    color:"#030712",}}>

  {/* filteredIndo[inx]?.name */}
  <span
    className='zara-regular'

    style={{
      display: "inline-block",
      fontSize:"9.898pt",
      lineHeight: "12.9px",
      letterSpacing: "-0.04em",
      fontWeight: 400,
  
    }}
  >
   {extractedSizeNumber}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    className='zara-regular'
    style={{
      display: "inline-block",
      fontSize:"7.486pt",
      lineHeight: "8.04px",
      letterSpacing: "-0.04em",
      fontWeight: 400,


    }}
  >
    {sizeValue?.includes("months") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <div style={{ display:"flex", justifyContent:"center", alignItems:"center" }}>
  <span
     className='zara-regular'
     style={{
       display: "inline-block",
       fontSize: "7.486pt",
       lineHeight: "12px",
       letterSpacing: "-0.04em",
       fontWeight: 400
  
     }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
  className='zara-regular'
    style={{
      display: "inline-block",
      fontSize: "7.486pt",
      marginRight:-2,
      marginLeft:2,
    }}
  >
    CM
  </span>
  </div>

        </div>


    </div>
  );
};




// Bileşenleri bir obje içinde saklıyoruz
const components = {
  KEEPAWAY,

};

// Gelen referansa göre bileşeni seçiyoruz
const Page1 = ({ selectColor,barcodeValue,data,harmacn,referance,SouthAmerica,sizeData,indo,szrgrp,inx,CardBackBack }) => {
  const [currentShape, setCurrentShape] = useState(null)
  
  const referanceCode = referance?.code?.trim()?.replace(/\s+/g, '') || '';

  const Component = components[referanceCode];

  const department = data.department
  const [brand, category, subCategory] = department.split(' / ')
  const filteredIndo = (indo || []).filter((item) => item.amount !== '')

  const indexedIndo = (indo || []).reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const valueBasedOnInx = indexedIndo[inx]

  // useEffect hook'u her zaman en üstte olmalı (conditional return'den önce)
  useEffect(() => {
    if (subCategory) {
      setCurrentShape(subCategory)
    }
  }, [subCategory])

  if (!Component) {
    return <div>Component bulunamadı: {referanceCode || referance?.code}</div>;
  }
  
  return (
    <Component 
      currentShape={currentShape}  
      category={category} 
      referance={referance} 
      CountryName={data?.country?.name} // ✅ Hata düzeltildi
      filteredIndo={filteredIndo}
      inx={inx}
      szrgrp={szrgrp}
      valueBasedOnInx={valueBasedOnInx}
      CardBackBack={CardBackBack}
    />
  );};

export default Page1;
